module.exports = __webpack_public_path__ + "files/ae2b6f4374a0e6ad9f7cfd75b3b68fd3.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Fraktur-Regular.woff2
// module id = 1081
// module chunks = 60